// extracted by mini-css-extract-plugin
export default {"container":"Y2-z","heading":"Z2-z","links":"_2-z","copy":"a3-z","subCopy":"b3-z","linksLeft":"c3-z","linksCenter":"d3-z","linksRight":"e3-z","link":"f3-z","onlyLink":"g3-z"};